export const NAVBAR_GREEN_GRADIENT = "linear-gradient(135deg, #2cb96a, #1e9e55)";
export const DARK_GREEN_GRADIENT =
  "linear-gradient(135deg, #2cb96a 0%, #1e9e55 52%, #166f3c 100%)";
export const AMBER_GRADIENT =
  "linear-gradient(135deg, #F59E0B 0%, #D97706 52%, #B45309 100%)";

// Premium upsell card fill. Deep enough that white text and the gold accent below read
// as high contrast — the same trick that makes HiddenPackageUpsellDialog's navy card
// feel premium, kept in brand green. Pale tints on a near-white body do not.
export const DEEP_GREEN_CARD_GRADIENT =
  "linear-gradient(135deg, #14683c 0%, #0f5132 55%, #0b3f27 100%)";

// Gold accents that ride on the deep cards: badge fill and the savings/highlight text.
export const GOLD_BADGE_GRADIENT =
  "linear-gradient(135deg, #ffe681 0%, #FACC15 100%)";
export const GOLD_TEXT = "#FFE066";
export const GOLD_HAIRLINE = "rgba(250,204,21,0.28)";
export const RED_GRADIENT =
  "linear-gradient(135deg, #EF4444 0%, #DC2626 52%, #B91C1C 100%)";
